export default {
  data() {
    return {
      isShowTips: false,
    };
  },
  methods: {
    // 用户第一次打开
    firstOpen() {
      const hasOpend = localStorage.getItem("hasOpened");
      // console.log("是否打开的", hasOpend, !hasOpend);
      if (!hasOpend) {
        setTimeout(() => {
          // debugger;
          this.isShowTips = true;
          // console.log("isShowTips", this.isShowTips);
          localStorage.setItem("hasOpened", true);
        }, 1000);
      } else {
        this.isShowTips = false;
      }
    },
  },
};
